import React from 'react';
import { View, Image } from 'react-native';
import Label from '../../common/Label';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import { getOnboardingPalette } from '../onboardingPalette';

const OnboardingOne = () => {
  const theme = useCustomTheme();
  const t = useTranslation({ defaultPath: 'onboarding.page1' });
  const palette = getOnboardingPalette(0, !!theme.isDark);
  return (
    <View style={{ backgroundColor: palette.backgroundColor, position: 'relative', flexGrow: 1, width: 625 }}>
      <Image
        {...({ pointerEvents: 'none' } as any)}
        source={require('../../../../assets/onBoarding_desktop_1.png')}
        style={{ position: 'absolute', top: 0, right: -1, aspectRatio: '1/1', maxWidth: 462, height: 496 }}
      />
      <View style={{ position: 'absolute', bottom: 59, left: 36, flexGrow: 1 }}>
        <View>
          <Label style={{ fontSize: 26, color: palette.titleColor, fontWeight: '600', width: 240 }}>{t('title')}</Label>
          <Label style={{ marginTop: 20, fontSize: 18, color: palette.subtitleColor, fontWeight: '400', width: 240 }}>{t('subtitle')}</Label>
          <Label style={{ fontSize: 15, marginTop: 24, color: palette.bodyColor, width: 320 }} numberOfLines={10}>
            {t('description')}
          </Label>
        </View>
      </View>
    </View>
  );
};

export default OnboardingOne;
